import { CircleInitials } from 'components/CircleInitials';
import { APIHistory, useCurrentUser } from 'hooks/queries';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

export type APIKeyHistoryItemProps = {
  historyEvent: APIHistory;
  module: string;
};

export const APIKeyHistoryItem: React.FC<APIKeyHistoryItemProps> = ({
  historyEvent,
  module,
}: APIKeyHistoryItemProps) => {
  const currentUser = useCurrentUser();
  const { t } = useTranslation();

  const perspectiveTranslationKey =
    'features:collaboration:api-management:keyHistory:perspectives';
  let perspective;
  if (module === 'apiKeyGenerator' && !currentUser.isGlobalUser) {
    if (historyEvent.activity === 'transferred') {
      perspective = t(`${perspectiveTranslationKey}:${'thirdPerson'}`);
    } else {
      perspective = t(`${perspectiveTranslationKey}:${'secondPerson'}`);
    }
  } else {
    perspective = t(`${perspectiveTranslationKey}:${'thirdPerson'}`);
  }

  return (
    <div className="my-6 flex flex-col">
      <div className="text-grey-600 ml-5 pl-3">
        {new Date(historyEvent.dateOfActivity).toLocaleString('en-GB', {
          minute: '2-digit',
          hour: '2-digit',
          day: '2-digit',
          month: 'short',
          year: 'numeric',
        })}
      </div>
      <div className="flex flex-row">
        <div>
          <CircleInitials name={historyEvent.userName} />
        </div>
        <div className="mt-1">
          <Trans
            i18nKey={`features:collaboration:api-management:keyHistory:historyItem_${historyEvent.activity}`}
            values={{
              userName: historyEvent.userName,
              perspective,
              activity: historyEvent.activity,
              projectName: historyEvent.projectName,
              apiKey: historyEvent.apiKey,
              fromUserName: historyEvent.fromUserName,
              toUserName: historyEvent.toUserName,
            }}
          />
        </div>
      </div>
      <span
        className="bg-grey-200 w-2px absolute ml-3 mt-9 h-7"
        aria-hidden="true"
      />
    </div>
  );
};
